module.exports = __webpack_public_path__ + "static/media/kettle-desaturated.cf153464.svg";